import challengeHeader from '../assets/TEXT.png';

function comingSoon() {
    var countdownDate = new Date('Jan 21, 2026 00:00:00').getTime();

    var countdownText = setInterval(function () {
        var now = new Date().getTime();

        var distance = countdownDate - now;

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        var daysText = '';
        var hoursText = '';
        var minutesText = '';
        var secondsText = '';

        daysText = days;

        if (hours < 10) {
            hoursText = '0' + hours;
        } else {
            hoursText = hours;
        }

        if (minutes < 10) {
            minutesText = '0' + minutes;
        } else {
            minutesText = minutes;
        }

        if (seconds < 10) {
            secondsText = '0' + seconds;
        } else {
            secondsText = seconds;
        }

        // Display the result in the element with id="demo"
        document.getElementById('countdownText').innerHTML = daysText + ':' + hoursText + ':' + minutesText + ':' + secondsText;

        // If the count down is finished, write some text
        if (distance < 0) {
            clearInterval(countdownText);
            document.getElementById('countdownText').innerHTML = '00:00:00:00';
        }
    }, 1000);

    return (
        <div className="text-center">
            <div className="absolute inset-0 bg-[#350A14]" />
            <div className="absolute w-1/2 h-1/2 mt-[10%] ml-[23.5%] flex flex-col justify-center items-center">
                <div className="flex flex-col mb-20">
                    <img className="w-full sm:w-3/4 mx-auto scale-150 sm:scale-100" src={challengeHeader} alt="" />
                </div>
                <div className="flex flex-col items-center">
                    <h2 className="font-sans font-normal uppercase m-0 text-[#d8a051] opacity-75 text-xs sm:text-xl">Challenge Begins In:</h2>
                    <h1 className="font-sans font-bold m-0 text-[#d8a051] text-[4.5rem] sm:text-[8rem]" id="countdownText">
                        00:00:00:00
                    </h1>
                </div>
            </div>
        </div>
    );
}

export default comingSoon;
